import React from "react";
import RoutingLayout from "./routing";

export enum LayoutType {
  ROUTING = "routing",
  BACKOFFICE = "backoffice",
}

const AppLayout = ({ layoutType = LayoutType.ROUTING }: { layoutType?: LayoutType }) => { 
  return <RoutingLayout />;
};

export default AppLayout;
